// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"517":"160f8d70","981":"eec1e595"}[chunkId] + ".chunk.js";
};